import {NgModule} from '@angular/core';
import {TableControlComponent} from './table-control.component';
import {NgxResizeObserverModule} from 'ngx-resize-observer';
import {AsyncPipe, NgFor, NgIf} from '@angular/common';
import {MatButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';
import {MatDivider} from '@angular/material/divider';
import {MatCheckbox} from '@angular/material/checkbox';
import {AgGridModule} from 'ag-grid-angular';
import {ValueOrFunctionPipe} from '../../../pipes/value-or-function.pipe';
import {HelpIconComponent} from '../../help-icon/help-icon.component';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [TableControlComponent],
  imports: [
    AgGridModule,
    HelpIconComponent,
    AsyncPipe,
    MatButton,
    MatCheckbox,
    MatDivider,
    MatIcon,
    MatProgressSpinner,
    MatTooltip,
    NgFor,
    NgIf,
    NgxResizeObserverModule,
    ValueOrFunctionPipe,
  ],
  exports: [
    AgGridModule,
    HelpIconComponent,
    AsyncPipe,
    MatButton,
    MatCheckbox,
    MatDivider,
    MatIcon,
    MatProgressSpinner,
    MatTooltip,
    NgFor,
    NgIf,
    NgxResizeObserverModule,
    TableControlComponent,
    ValueOrFunctionPipe,
  ],
})
export class TableControlModule {

}
